import Grow from '@mui/material/Grow';
import { Components, Theme } from '@mui/material';

export type LelyDialogSize = 'sm' | 'md' | 'lg';

declare module '@mui/material/Dialog' {
  interface DialogProps {
    size?: LelyDialogSize;
  }
}

const dialogViewportWidth = 'calc(100vw - 40px)';
const dialogViewportMaxHeight = 'calc(100vh - 40px)';

export const getDialogComponents = (
  theme: Theme,
): Pick<
  Components<Theme>,
  'MuiDialog' | 'MuiDialogTitle' | 'MuiDialogContent' | 'MuiDialogActions'
> => ({
  MuiDialog: {
    defaultProps: {
      maxWidth: false,
      size: 'md',
      transitionDuration: 300,
      slots: {
        transition: Grow,
      },
    },

    styleOverrides: {
      paper: {
        width: dialogViewportWidth,
        maxHeight: dialogViewportMaxHeight,
        overflow: 'hidden',
        border: 'none',
        borderRadius: theme.lelyBorderRadius.SM,
        backgroundColor: theme.palette.background.light,
      },
    },

    variants: [
      {
        props: { size: 'sm' },
        style: {
          '& .MuiDialog-paper': {
            minWidth: 280,
            maxWidth: 480,
          },
        },
      },
      {
        props: { size: 'md' },
        style: {
          '& .MuiDialog-paper': {
            minWidth: 480,
            maxWidth: 720,
          },
        },
      },
      {
        props: { size: 'lg' },
        style: {
          '& .MuiDialog-paper': {
            minWidth: 720,
            maxWidth: 1024,
          },
        },
      },
    ],
  },

  MuiDialogTitle: {
    styleOverrides: {
      root: {
        height: theme.lelySpacing._8XL,
        padding: `${theme.lelySpacing.MD} ${theme.lelySpacing.LG}`,
      },
    },
  },

  MuiDialogContent: {
    styleOverrides: {
      root: {
        minHeight: 0,
        padding: `${theme.lelySpacing.SM} ${theme.lelySpacing.LG}`,

        // MUI sets paddingTop: 0 when DialogContent follows DialogTitle
        '.MuiDialogTitle-root + &': {
          paddingTop: theme.lelySpacing.SM,
        },
      },
    },
  },

  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: theme.lelySpacing.LG,
        gap: theme.lelySpacing.LG,
      },
    },
  },
});
